import BaseViewController from "./base-view-controller";

export default class ManualPharmacyViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name) {
    const {
      values: {
        "manual_pharmacy.pharmacy_nm": pharmacyName,
        "manual_pharmacy.phone.phone_number": number,
        "manual_pharmacy.address.address_line1": address1,
        "manual_pharmacy.address.address_line2": address2,
        "manual_pharmacy.address.city": city,
        "manual_pharmacy.address.state_province": state,
        "manual_pharmacy.address.postal": zipCode
      }
    } = this.appData;
    const numberFormatted = /^\d+$/.test(number)
      ? `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`
      : number;
    this.formState = {
      pharmacy_view: `${pharmacyName}\n${address1} ${
        address2 || ""
      }\n${city}, ${state} ${zipCode}\n${numberFormatted}`
    };
    super.handleButtonClick(name);
  }
}
